import React, { useEffect, useRef, useState } from "react";

interface SponsorData {
  name: string;
  tagline?: string;
  logo: string; // Path to logo image in /Sponsor_Logos/
  color: string; // Brand accent color
}

const sponsors: SponsorData[] = [
  {
    name: "Victory Auto World",
    tagline: "Ford · Isuzu Ute · LDV · MG",
    logo: "/Sponsor_Logos/Victory Auto World.png",
    color: "#003478",
  },
  {
    name: "Tweed Coast Marine",
    tagline: "Boating Made Easy",
    logo: "/Sponsor_Logos/Tweed Coast Marine.png",
    color: "#0077B6",
  },
  {
    name: "CHG Care & Support",
    tagline: "",
    logo: "/Sponsor_Logos/CHG Care & Support.png",
    color: "#2E86AB",
  },
  {
    name: "IC Signs",
    tagline: "",
    logo: "/Sponsor_Logos/IC Signs.png",
    color: "#E63946",
  },
  {
    name: "Novas Glass",
    tagline: "Repair · Replacement",
    logo: "/Sponsor_Logos/Novas Glass.png",
    color: "#1D3557",
  },
  {
    name: "Creativ Energy",
    tagline: "Renewable Solar Design & Install",
    logo: "/Sponsor_Logos/Creativ Energy.png",
    color: "#F4A261",
  },
  {
    name: "CNC Marine",
    tagline: "",
    logo: "/Sponsor_Logos/CNC Marine.png",
    color: "#264653",
  },
  {
    name: "Tumbulgum Tavern",
    tagline: "",
    logo: "/Sponsor_Logos/Tumbulgum Tavern.png",
    color: "#6B4226",
  },
  {
    name: "Addict Tackle",
    tagline: "Mark Bergs · Tweed Heads",
    logo: "/Sponsor_Logos/Addict Tackle.png",
    color: "#E76F51",
  },
  {
    name: "S-Tackle",
    tagline: "",
    logo: "/Sponsor_Logos/S-Tackle.png",
    color: "#2A9D8F",
  },
  {
    name: "Husk Rum",
    tagline: "Farm to Bottle",
    logo: "/Sponsor_Logos/Husk Rum.png",
    color: "#8B4513",
  },
  {
    name: "Orca Marine",
    tagline: "",
    logo: "/Sponsor_Logos/Orca Marine.png",
    color: "#023E8A",
  },
  {
    name: "Lawrence & Hanson",
    tagline: "Electrical · Solar · Data · Lighting since 1886",
    logo: "/Sponsor_Logos/Lawrence & Hanson.png",
    color: "#FFB703",
  },
  {
    name: "Whole Being",
    tagline: "Disability & Aged Care",
    logo: "/Sponsor_Logos/Whole Being.png",
    color: "#6A994E",
  },
  {
    name: "RCC",
    tagline: "",
    logo: "/Sponsor_Logos/RCC.png",
    color: "#495057",
  },
  {
    name: "Tumby Park",
    tagline: "",
    logo: "/Sponsor_Logos/Tumby Park.png",
    color: "#40916C",
  },
  {
    name: "Williams",
    tagline: "",
    logo: "/Sponsor_Logos/Williams.png",
    color: "#1B4332",
  },
  {
    name: "PKM Constructions",
    tagline: "",
    logo: "/Sponsor_Logos/PKM Constructions.png",
    color: "#BC6C25",
  },
  {
    name: "Berger Houseboats",
    tagline: "",
    logo: "/Sponsor_Logos/Berger Houseboats.png",
    color: "#0096C7",
  },
  {
    name: "CTM Earthworx",
    tagline: "",
    logo: "/Sponsor_Logos/CTM Earthworx.png",
    color: "#DDA15E",
  },
  {
    name: "SAE",
    tagline: "Solar Aircon Electrical",
    logo: "/Sponsor_Logos/SAE.png",
    color: "#E9C46A",
  },
  {
    name: "Border Plumbing",
    tagline: "",
    logo: "/Sponsor_Logos/Border Plumbing.png",
    color: "#457B9D",
  },
  {
    name: "Accent Benchtops",
    tagline: "",
    logo: "/Sponsor_Logos/Accent Benchtops.png",
    color: "#6D6875",
  },
  {
    name: "Far North Coast Fencing",
    tagline: "",
    logo: "/Sponsor_Logos/Far North Coast Fencing.png",
    color: "#588157",
  },
  {
    name: "Dirty Farm Slashing",
    tagline: "",
    logo: "/Sponsor_Logos/Dirty Farm Slashing.png",
    color: "#606C38",
  },
  {
    name: "Hey Presto Electrical",
    tagline: "",
    logo: "/Sponsor_Logos/Hey Presto Electrical.png",
    color: "#FFBA08",
  },
  {
    name: "All Powered Up",
    tagline: "",
    logo: "/Sponsor_Logos/All Powered Up.png",
    color: "#D62828",
  },
  {
    name: "Brims",
    tagline: "Concrete · Haulage & Materials",
    logo: "/Sponsor_Logos/Brims.png",
    color: "#6C757D",
  },
  {
    name: "Matt Schultz Plastering",
    tagline: "",
    logo: "/Sponsor_Logos/Matt Schultz Plastering.png",
    color: "#ADB5BD",
  },
  {
    name: "TMM",
    tagline: "Timmy's Mobile Mechanic",
    logo: "/Sponsor_Logos/TMM.png",
    color: "#343A40",
  },
  {
    name: "Home Kitchens & Cabinetry",
    tagline: "",
    logo: "/Sponsor_Logos/Home Kitchens & Cabinetry.png",
    color: "#774936",
  },
  {
    name: "Judy Emzin Bookkeeping",
    tagline: "",
    logo: "/Sponsor_Logos/Judy Emzin Bookkeeping.png",
    color: "#5F0F40",
  },
  {
    name: "Dan Purkis Pest Control",
    tagline: "",
    logo: "/Sponsor_Logos/Dan Purkis Pest Control.png",
    color: "#3A5A40",
  },
  {
    name: "Oconnors",
    tagline: "Carrying Service",
    logo: "/Sponsor_Logos/Oconnors.png",
    color: "#4A4E69",
  },
  {
    name: "Hayes Toyota",
    tagline: "",
    logo: "/Sponsor_Logos/Hayes Toyota.png",
    color: "#EB0A1E",
  },
  {
    name: "Debbie Conti Property",
    tagline: "",
    logo: "/Sponsor_Logos/Debbie Conti Property.png",
    color: "#9B2226",
  },
  {
    name: "The Weekly",
    tagline: "Locally Owned · Proudly Tweed",
    logo: "/Sponsor_Logos/The Weekly.png",
    color: "#005F73",
  },
  {
    name: "Betit",
    tagline: "",
    logo: "/Sponsor_Logos/Betit.png",
    color: "#0A9396",
  },
  {
    name: "Raptor Waste Management",
    tagline: "",
    logo: "/Sponsor_Logos/Raptor Waste Management.png",
    color: "#94D2BD",
  },
  {
    name: "Sunnyside Meats",
    tagline: "",
    logo: "/Sponsor_Logos/Sunnyside Meats.png",
    color: "#BB3E03",
  },
  {
    name: "DJ Stringer",
    tagline: "Property Services",
    logo: "/Sponsor_Logos/DJ Stringer.png",
    color: "#CA6702",
  },
  {
    name: "Whiteley & Sons",
    tagline: "Solar & Electrical",
    logo: "/Sponsor_Logos/Whiteley & Sons.png",
    color: "#EE9B00",
  },
  {
    name: "Mercury",
    tagline: "",
    logo: "/Sponsor_Logos/Mercury.png",
    color: "#1B263B",
  },
  {
    name: "Quintrex",
    tagline: "",
    logo: "/Sponsor_Logos/Quintrex.png",
    color: "#415A77",
  },
  {
    name: "Tweed Escapes",
    tagline: "",
    logo: "/Sponsor_Logos/Tweed Escapes.png",
    color: "#2A6F97",
  },
];

/** True when the user has asked the OS for reduced motion. */
function usePrefersReducedMotion(): boolean {
  const query = '(prefers-reduced-motion: reduce)';
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(query).matches,
  );
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia(query);
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, []);
  return reduced;
}

/** Mobile pixels per frame (desktop uses 0.5 on wider cards). */
const MOBILE_SPEED = 0.4;
/** After a swipe, wait this long before auto-scroll resumes. */
const MOBILE_RESUME_MS = 2500;

const SponsorBanner: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  // #120: mobile gets the same scrolling banner, sized for a phone. It can be
  // swiped; a touch pauses auto-scroll, which resumes shortly after. With
  // prefers-reduced-motion there is no auto-scroll at all, swipe only.
  const mobileScrollRef = useRef<HTMLDivElement>(null);
  const [mobilePaused, setMobilePaused] = useState(false);
  const resumeTimer = useRef<number | undefined>(undefined);
  const reducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const el = mobileScrollRef.current;
    if (!el || reducedMotion) return;
    let animationId: number;
    // Continue from wherever a swipe left it.
    let scrollPos = el.scrollLeft;
    const animate = () => {
      if (!mobilePaused) {
        scrollPos += MOBILE_SPEED;
        const halfWidth = el.scrollWidth / 2;
        if (halfWidth > 0 && scrollPos >= halfWidth) scrollPos -= halfWidth;
        el.scrollLeft = scrollPos;
      } else {
        scrollPos = el.scrollLeft;
      }
      animationId = requestAnimationFrame(animate);
    };
    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [mobilePaused, reducedMotion]);

  useEffect(() => () => window.clearTimeout(resumeTimer.current), []);

  const pauseMobile = () => {
    window.clearTimeout(resumeTimer.current);
    setMobilePaused(true);
  };
  const resumeMobileSoon = () => {
    window.clearTimeout(resumeTimer.current);
    resumeTimer.current = window.setTimeout(() => setMobilePaused(false), MOBILE_RESUME_MS);
  };

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationId: number;
    let scrollPos = 0;
    const speed = 0.5;

    const animate = () => {
      if (!isPaused && scrollContainer) {
        scrollPos += speed;
        const halfWidth = scrollContainer.scrollWidth / 2;
        if (scrollPos >= halfWidth) {
          scrollPos = 0;
        }
        scrollContainer.scrollLeft = scrollPos;
      }
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [isPaused]);

  // Duplicate sponsors for seamless loop
  const allSponsors = [...sponsors, ...sponsors];

  return (
    <section
      id="sponsors"
      className="relative py-6 md:py-8 overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #003366 0%, #005599 30%, #007ACC 60%, #0A5C3B 100%)",
      }}
      aria-label="Our Sponsors"
    >
      {/* Subtle wave decoration top */}
      <div
        className="absolute top-0 left-0 right-0 overflow-hidden"
        style={{ height: "40px" }}
      >
        <svg
          viewBox="0 0 1200 40"
          preserveAspectRatio="none"
          className="w-full h-full"
        >
          <path
            d="M0,20 C200,40 400,0 600,20 C800,40 1000,0 1200,20 L1200,0 L0,0 Z"
            fill="rgba(255,255,255,0.05)"
          />
        </svg>
      </div>

      {/* Header */}
      <div className="text-center mb-4 px-4">
        <div className="flex items-center justify-center gap-3 mb-3">
          <span className="text-2xl">🐟</span>
          <h2 className="text-2xl md:text-3xl font-bold text-white tracking-tight">
            Our Proud Sponsors
          </h2>
          <span className="text-2xl">🐟</span>
        </div>
        <p className="text-blue-200 text-sm md:text-base max-w-xl mx-auto">
          Thank you to the local businesses and community partners who support
          the Tumbulgum Fishing Club
        </p>
        <div
          className="mt-3 mx-auto w-24 h-1 rounded-full"
          style={{ background: "#FFD700" }}
        />
      </div>

      {/* Scrolling banner - Desktop */}
      <div className="hidden md:block">
        <div
          ref={scrollRef}
          className="flex gap-6 overflow-hidden px-4 cursor-pointer"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onFocus={() => setIsPaused(true)}
          onBlur={() => setIsPaused(false)}
          role="marquee"
          aria-label="Scrolling sponsor logos — hover to pause"
          tabIndex={0}
        >
          {allSponsors.map((sponsor, i) => (
            <SponsorCard key={`${sponsor.name}-${i}`} sponsor={sponsor} />
          ))}
        </div>
      </div>

      {/* Scrolling banner - Mobile (#120). Swipeable; auto-scrolls unless the
          user prefers reduced motion. Duplicated list for the seamless loop,
          except under reduced motion, where each sponsor appears once. */}
      <div className="md:hidden">
        <div
          ref={mobileScrollRef}
          data-testid="sponsor-scroller-mobile"
          className="flex gap-3 overflow-x-auto px-4 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          onTouchStart={pauseMobile}
          onTouchEnd={resumeMobileSoon}
          onPointerDown={pauseMobile}
          onPointerUp={resumeMobileSoon}
          onFocus={pauseMobile}
          onBlur={resumeMobileSoon}
          role="region"
          aria-label={reducedMotion ? 'Sponsor logos, swipe to see more' : 'Scrolling sponsor logos, swipe or touch to pause'}
          tabIndex={0}
        >
          {(reducedMotion ? sponsors : allSponsors).map((sponsor, i) => (
            <div key={`${sponsor.name}-${i}`} className="w-28 shrink-0" aria-hidden={i >= sponsors.length || undefined}>
              <SponsorCard sponsor={sponsor} compact />
            </div>
          ))}
        </div>
      </div>

      {/* Subtle wave decoration bottom */}
      <div
        className="absolute bottom-0 left-0 right-0 overflow-hidden"
        style={{ height: "40px" }}
      >
        <svg
          viewBox="0 0 1200 40"
          preserveAspectRatio="none"
          className="w-full h-full"
        >
          <path
            d="M0,20 C200,0 400,40 600,20 C800,0 1000,40 1200,20 L1200,40 L0,40 Z"
            fill="rgba(255,255,255,0.05)"
          />
        </svg>
      </div>
    </section>
  );
};

const SponsorCard: React.FC<{ sponsor: SponsorData; compact?: boolean }> = ({
  sponsor,
  compact,
}) => {
  const [imgError, setImgError] = useState(false);

  return (
    <div
      className={`
        flex-shrink-0 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20
        hover:bg-white/20 hover:border-white/40 hover:scale-105
        transition-all duration-300 group
        ${
          compact
            ? "p-3 flex flex-col items-center justify-center text-center"
            : "p-4 w-48 flex flex-col items-center justify-center text-center"
        }
      `}
      title={
        sponsor.tagline ? `${sponsor.name} — ${sponsor.tagline}` : sponsor.name
      }
    >
      <div
        className={`
          rounded-lg flex items-center justify-center overflow-hidden
          bg-white
          ${compact ? "w-16 h-16 mb-1.5 p-1" : "w-28 h-28 mb-3 p-2"}
        `}
      >
        {imgError ? (
          <span
            className={`text-gray-400 font-bold ${compact ? "text-[8px]" : "text-xs"} text-center px-1`}
          >
            {sponsor.name}
          </span>
        ) : (
          <img
            src={sponsor.logo}
            alt={`${sponsor.name} logo`}
            className="w-full h-full object-contain"
            onError={() => setImgError(true)}
            loading="lazy"
          />
        )}
      </div>
      <span
        className={`
          text-white font-semibold leading-tight
          ${compact ? "text-[10px] sm:text-xs" : "text-xs"}
        `}
      >
        {sponsor.name}
      </span>
      {!compact && sponsor.tagline && (
        <span className="text-blue-200 text-[10px] mt-1 leading-tight opacity-80">
          {sponsor.tagline}
        </span>
      )}
    </div>
  );
};

export default SponsorBanner;
